import React from "react";
import { Resources } from "../../components/Resources/Resources";
import { SampleReports } from "../../components/Resources/SampleReports";
import {
  HelpPanelResourceCard,
  HelpPanelResourceSection,
  HelpPanelResourceTitle,
  HelpPanelResources,
} from "./Help.styles";

export const UnityCompleteResources = (): React.ReactElement => (
  <HelpPanelResources data-testid="unity-complete-resources">
    <HelpPanelResourceSection>
      <HelpPanelResourceTitle>Resources</HelpPanelResourceTitle>
      <HelpPanelResourceCard>
        <Resources showTitle={false} />
      </HelpPanelResourceCard>
    </HelpPanelResourceSection>
    <HelpPanelResourceSection>
      <HelpPanelResourceTitle>Sample Reports</HelpPanelResourceTitle>
      <HelpPanelResourceCard>
        <SampleReports showTitle={false} />
      </HelpPanelResourceCard>
    </HelpPanelResourceSection>
  </HelpPanelResources>
);
